const ioOverlayViewTemplate = ({loaderImg, loaderAltText}) => `<div style="display:none" class="tsc-io-container">
    <div class="tsc-io-message">
        <span role="status" aria-live="polite"></span>
        <img src="${loaderImg}" alt="${loaderAltText}" aria-hidden="true"/>
    </div>
</div>`;

export default ioOverlayViewTemplate;
